import PropTypes from 'prop-types';
import useExperiment from './useExperiment';
import useForcedExperiment from './useForcedExperiment';

const TargetedDelivery = (props) => {
  const { children, flagKey } = props;
  const [isEnabled] = useExperiment(flagKey);
  const [isForcedEnabled] = useForcedExperiment(flagKey);
  const result = isEnabled || isForcedEnabled ? children : null;
  return result;
};

TargetedDelivery.propTypes = {
  flagKey: PropTypes.string.isRequired,
};

export default TargetedDelivery;
